export default {
  statistics: {
    total_campaigns: 'Total de campañas',
    todays_sent_messages: 'Mensajes enviados hoy',
    total_subscribers: 'Suscriptores',
    average_click_rate: 'Tasa media de clics',
  },
};
